import Repository from "./Repository";

const GET_GLOBALFORM = "get";
const CREATE_GLOBALFORM = "add";
const EDIT_GLOBALFORM = "edit";
const DELETE_GLOBALFORM = "delete";

export default {
  getglobalform(payload) {
    return Repository.post(transformRoute(GET_GLOBALFORM), payload);
  },
  addglobalform(payload) {
    return Repository.post(transformRoute(CREATE_GLOBALFORM), payload);
  },
  editglobalform(payload) {
    return Repository.post(transformRoute(EDIT_GLOBALFORM), payload);
  },
  deleteglobalform(payload) {
    return Repository.post(transformRoute(DELETE_GLOBALFORM), payload);
  },
};

const transformRoute = (route) => {
  return `globalform/${route}`;
};
